// visualBeatRegistry — the single place components register declarative beat-visual listeners.
// Avoids scattered BeatClock subscriptions across unrelated components.
let _seq = 0;

class VisualBeatRegistry {
  constructor() {
    if (VisualBeatRegistry._i) return VisualBeatRegistry._i;
    this.listeners = new Map(); // id -> { event, effect, intensity, enabled, cb }
    VisualBeatRegistry._i = this;
  }
  register(entry) {
    const id = `bv_${++_seq}`;
    this.listeners.set(id, { intensity: "subtle", enabled: true, ...entry });
    return id;
  }
  update(id, patch) { const e = this.listeners.get(id); if (e) this.listeners.set(id, { ...e, ...patch }); }
  unregister(id) { this.listeners.delete(id); }
  forEvent(event) {
    return [...this.listeners.values()].filter((l) => l.enabled && l.event === event);
  }
  count() { return this.listeners.size; }
  effects() { return [...new Set([...this.listeners.values()].map((l) => l.effect))]; }
}

export const visualBeatRegistry = new VisualBeatRegistry();
export default visualBeatRegistry;
